export default "__VITE_ASSET__BnqsMXoo__"